export const DRAWER_TRANSITION = {
    duration: 250, 
    type: 'timing'
}

export const BACKDROP_TRANSITION = {
    duration: 500, 
    type: 'timing', 
    left: {
        type: 'timing', 
        duration: 1
    },
    right: {
        type: 'timing',
        duration: 1
    }
};

export const animtedStyleProps = (position, width) => {
    if (position === 'left') {
        return {
            to: {
                left: 0,
                right: 'auto'
            },
            from: {
                left: ( width * 1.25) * -1,
                right: 'auto'
            }
        }
    }

    return {
        to: {
            left: 'auto',
            right: 0,
        },
        from: {
            left: 'auto',
            right: (width * 1.25) * -1
        }
    }
}

export const animatedBackdrop = (position, windowWidth) => {
    if (position === 'left') {
        return {
            to: {
                opacity: 1,
                left: 0,
                right: 'auto'
            },
            from: {
                opacity: 0,
                left: windowWidth *-1,
                right: 'auto'
            }
        }
    }

    return {
        to: {
            opacity: 1,
            left: 'auto',
            right: 0
        },
        from: {
            opacity: 0,
            left: 'auto',
            right: windowWidth *-1
        }
    }
};